"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReminderTitle = exports.createAgileReminder = void 0;
const adaptivecards_1 = require("adaptivecards");
const moment_1 = __importDefault(require("moment"));
const commands_1 = require("../../_shared/commands");
const AppealTitle_1 = require("../../_shared/components/AppealTitle");
const DetailsBar_1 = require("../../_shared/components/DetailsBar");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const commands_2 = require("../../survey/commands");
function createAgileReminder(survey, appealConversationId, messageId) {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `⚠️Reminder: ${getReminderTitle(survey)}`,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Left,
        size: adaptivecards_1.TextSize.Medium,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    card.addItem((0, AppealTitle_1.AppealTitle)(survey));
    if (survey.description) {
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: survey.description,
            spacing: adaptivecards_1.Spacing.Medium,
        }));
    }
    card.addItem((0, DetailsBar_1.detailsBar)(survey, { hideOwner: false, hideAnonymity: true }));
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: "Respond now",
        isPrimary: true,
        data: (0, commands_1.takingStartCommand)(survey.id).toTaskFetchCommand(),
    }));
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
        title: "View results",
        data: (0, commands_2.SurveyResultsViewCommand)(survey.id).toTaskFetchCommand(),
    }));
    if (appealConversationId) {
        card.addAction((0, commands_1.SurveyDeepLinkAction)(survey.tenantId, survey.type, appealConversationId));
    }
    card.addAction((0, commands_1.DeleteCardAction)(messageId));
    return card;
}
exports.createAgileReminder = createAgileReminder;
function getReminderTitle(survey, notification) {
    const prefix = `Your ${(0, CardHelper_1.getSurveyTypeDisplay)(survey.type)} is due at `;
    if (notification) {
        return `${prefix} ${(0, moment_1.default)(survey.closeAt).format("l LT")}.`;
    }
    return `${prefix} ${CardHelper_1.CardHelper.dateTimeReplacementString(survey.closeAt)}.`;
}
exports.getReminderTitle = getReminderTitle;
//# sourceMappingURL=AgileReminder.js.map